import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { MarksDataStructure } from "@virtus-tech-repository/virtus-tech-repository/lib/models/marks.model";
import { MarksHotspotData } from "../views/components/MarksEditContainer";

interface PostMarksHotspotData {
    scenarioId: string;
    data: MarksDataStructure;
}

// Define a service using a base URL and expected endpoints
export const marksApi = createApi({
    reducerPath: "marksApi",
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_NINJA_ENDPOINT,
    }),
    tagTypes: ["PostMarks"],
    endpoints: (builder) => ({
        getMarks: builder.query<MarksDataStructure, string>({
            query: (scenarioId) => ({
                url: `marks/${scenarioId}`,
                method: "GET",
            }),
            providesTags: ["PostMarks"],
            // transformResponse(){

            // }
            // Pick out errors and prevent nested properties in a hook or selector
            // transformErrorResponse: (response: { status: string | number }, meta, arg) => response.status,
        }),

        // The mutation accepts a `Partial<Post>` arg, and returns a `Post`
        updateMarks: builder.mutation<MarksHotspotData, Partial<PostMarksHotspotData>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: ({ scenarioId, data }) => ({
                url: `marks/${scenarioId}`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["PostMarks"],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetMarksQuery, useUpdateMarksMutation } = marksApi;
